import { useTranslation } from 'react-i18next';
import { assigneeOptions } from 'constants/forms';

import BaseSelect from './base';

import type { Option } from './base';
import type { FC } from 'react';

interface Props {
  value?: Option | null;
  showSelectAll?: boolean;
  onChange: (e: Option | null) => void;
}

const AssigneeSelect: FC<Props> = ({ onChange, value, showSelectAll }) => {
  const { t } = useTranslation();
  return (
    <BaseSelect
      label={t('labels.assignee')}
      data-cy="filter-assignee"
      placeholder={t('labels.all')}
      showSelectAll={showSelectAll}
      options={assigneeOptions}
      value={value}
      onChange={(newValue) => {
        if (!newValue) {
          return onChange(assigneeOptions[1]);
        }
        const items = Array.isArray(newValue) ? newValue : [newValue];
        onChange({
          value: items[0].value,
          label: items[0].label,
        });
      }}
    />
  );
};

export default AssigneeSelect;
